var _circle, _rect, _rect2, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenAndPurpleFlares(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_11_2",
    "data-name": "Component 11 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 319.156,
    height: 167.154,
    viewBox: "0 0 319.156 167.154",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 3.899,
    cy: 3.899,
    r: 3.899,
    transform: "translate(2.6 18.345)",
    fill: "#69efad"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 6.238,
    height: 6.238,
    transform: "translate(231.25 135.338) rotate(-45)",
    fill: "#69efad"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 6.238,
    height: 6.238,
    transform: "translate(247.792 4.411) rotate(-45)",
    fill: "#9460f5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 2.599,
    cy: 2.599,
    r: 2.599,
    transform: "translate(313.957 74.301)",
    fill: "#9460f5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 2.599,
    cy: 2.599,
    r: 2.599,
    transform: "translate(0 161.956)",
    fill: "#69efad"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenAndPurpleFlares);
export default __webpack_public_path__ + "static/media/greenAndPurpleFlares.0713085a898ac538bbad13aa20039833.svg";
export { ForwardRef as ReactComponent };